import { type MouseEvent, type MutableRefObject } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface IDueDayPickerContentProps {
  value?: number;
  close: (
    focusableElement?:
      | HTMLElement
      | MutableRefObject<HTMLElement | null>
      | MouseEvent<HTMLElement>,
  ) => void;
  onChange: (value: number) => void;
}

export const DueDayPickerContent: React.FC<IDueDayPickerContentProps> = (
  props,
) => {
  const { value, close, onChange } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 pb-4 pt-6">
      <div className="flex items-center px-4">
        <span className="text-base font-semibold">
          {t("dueDayPicker.selectDay")}
        </span>
      </div>
      <div className="grid w-72 grid-cols-7 gap-y-1 px-4">
        {Array.from({ length: 31 }).map((_, index) => (
          <button
            key={index}
            className={twMerge(
              "block flex-1 rounded-full text-center text-sm leading-9 hover:bg-grey-hover",
              value === index + 1 &&
                "bg-blue-dark text-white hover:bg-blue-dark",
            )}
            onClick={() => {
              onChange(index + 1);
              close();
            }}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};
